<template>
  <div>
    <div class="sga-page-6 page-6">
      <h3>Activities</h3>
      <p>
        <strong
          >What activities have you participated in (currently or previously)
          inside or outside of work? </strong
        ><br />
        <small
          >(This may include activities at home, school, in the community,
          volunteering or at work.)</small
        >
      </p>
      <el-form @submit.native.prevent>
        <label class="hide-sm" role="text">Activities</label>
        <el-form-item :required="true">
          <div class="ts-comp--multiselect columned">
            <div class="ts-comp--multiselect-item">
              <label class="header-label" role="title">&nbsp;</label>
              <div class="cols header-cols">
                <!-- <span class="employer">
                  <img src="~../../../../assets/img/icons/insiderole_icon.svg" alt="Expected by employer" class="hide-sm"/>
                  <strong>Expected by employer</strong>
                </span> -->
                <span class="i-add">
                  <img
                    src="~../../../../assets/img/icons/outsiderole_icon.svg"
                    alt="I add to role"
                    class="hide-sm"
                  />
                  <strong>I add to role</strong>
                </span>
              </div>
            </div>
            <div
              v-for="(activity, index) in workActivities"
              :key="`activity-${index}`"
              class="ts-comp--multiselect-item"
            >
              <label class="activity-label">
                {{ checkIfContainsOrganization(activity.activity) }}
              </label>
              <div class="cols">
                <!-- <span class="employer">
                  <el-checkbox @change="(v) => handleKnowledgeChange(activity.activity, 'IN', v)" v-model="knowledgeRegularlyUsed[activity.activity].in"></el-checkbox>
                </span> -->
                <span class="i-add">
                  <el-checkbox
                    @change="
                      v => handleKnowledgeChange(activity.activity, 'OUT', v)
                    "
                    v-model="knowledgeRegularlyUsed[activity.activity].out"
                  ></el-checkbox>
                </span>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <el-alert
        v-if="
          retrieveFieldError(
            modelState,
            'SgaHiddenExtras.WorkingPracticeActivities'
          )
        "
        :title="
          retrieveFieldError(
            modelState,
            'SgaHiddenExtras.WorkingPracticeActivities'
          )
        "
        type="error"
      ></el-alert>
      <el-alert
        v-if="activitiesError"
        :title="activitiesError"
        type="error"
        :closable="false"
      ></el-alert>

      <button
        class="ts-btn ts-btn-rounded ts-btn-secondary"
        @click="storeSection()"
      >
        Continue
      </button>
      <a class="back-link" href="/sga/questionnaire/5">
        <i class="fas fa-chevron-left"></i>Back
      </a>
    </div>
    <questionnaire-print
      ref="questionnaire"
      :page1="page1"
      :page2="page2"
      :page3="page3"
      :page4="page4"
      :page5="page5"
      :page6="page6"
      :page7="page7"
      :page8="page8"
      :page9="page9"
      :page10="page10"
      :page11="page11"
      :page12="page12"
      currentPage="page6"
    >
    </questionnaire-print>
    <!-- <JobSeekerCV ref="cv" :Image="Base64Raw" :Data="currentSga" :UserInfo="currentUser" :ShowProfile="showProfile"></JobSeekerCV>  -->
    <JobSeekerCV
      ref="cv"
      :Data="profile.survey"
      :profile="profile"
      :Image="base64Raw"
      :UserInfo="currentUser"
      :ShowProfile="showProfile"
    ></JobSeekerCV>
    <ResumeListSelection
      :ProfileSettings="profileSettings"
      :ShowControl="showResumeListModal"
      @close-control="closeResumeListModal"
      @show-resume="displayResume"
    ></ResumeListSelection>
    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>

<script>
import QuestionnairePrint from "../../components/QuestionnairePrint.vue";
import JobSeekerCV from "../../components/JobSeekerCV";
import TSLoading from "../../../../components/TSLoading.vue";
import ResumeListSelection from "../../components/ResumeListSelection.vue";

export default {
  components: {
    QuestionnairePrint,
    JobSeekerCV,
    TSLoading,
    ResumeListSelection
  },
  created() {
    this.locale = localStorage.getItem("locale");

    this.$store.dispatch("sga/getsga").then(res => {
      if (this.currentSga.sgaHiddenExtras != null) {
        if (res.sgaHiddenExtras.workingPracticeActivities != null) {
          res.sgaHiddenExtras.workingPracticeActivities.forEach(element => {
            element.value = "OUT";
          });
          this.sgaHiddenExtras = res.sgaHiddenExtras;
        } else {
          this.sgaHiddenExtras = this.currentSga.sgaHiddenExtras;
        }
      }

      this.$store.dispatch("onet/workActivities", "15-1132.00").then(res => {
        const mappedActivities = res.map(activity => {
          const activitySelection = this.sgaHiddenExtras
            .workingPracticeActivities[activity];

          return {
            checked: activitySelection !== undefined,
            rating:
              activitySelection !== undefined ? activitySelection.Rating : 0,
            activity,
            value: null
          };
        });

        this.$store
          .dispatch("sga/setWorkActivities", mappedActivities)
          .then(() => {
            this.isLoading = true;
            this.mapToCurrentActivities(
              this.sgaHiddenExtras.workingPracticeActivities
            );
            this.isLoading = false;
          });
      });
    });

    if (sessionStorage.getItem("profilephoto")) {
      this.base64Raw = sessionStorage.getItem("profilephoto");
    }
  },
  mounted() {
    this.$router.app.$on("questionnaire-print", this.printPage);
    // this.$router.app.$on('cv-print', this.printPageAsCV);
    this.$router.app.$on("show-resume-list", this.showResumeList);
  },
  destroyed() {
    if (
      this.$route.matched.find(c => c.path === "/sga/questionnaire") ===
      undefined
    ) {
      sessionStorage.removeItem("sgaDataForPrinting");
    } else {
      this.$router.app.$off("questionnaire-print", this.printPage);
      this.$router.app.$off("cv-print", this.printPageAsCV);
    }
  },
  data() {
    return {
      showResumeListModal: false,
      multipleSelection: [],
      isLoading: false,
      experienceDialog: true,
      modelState: {},
      sgaEmployeeInfo: {},
      sgaYourJob: {
        jobRole: {},
        JobDescriptionTasks: [],
        customTasks: []
      },
      sgaEducation: {
        secondLevelEducation: {
          highSchoolDiploma: false,
          ged: false,
          oLevels: false,
          oLevelDetails: [],
          leavingCert: false,
          aLevels: false,
          aLevelDetails: []
        },
        thirdLevelEducation: {
          associateDegree: false,
          associateDegreeDetails: [],
          bachelorsDegree: false,
          bachelorsDegreeDetails: []
        },
        fourthLevelEducation: {
          mastersDegree: false,
          mastersDegreeDetails: [],
          doctoralDegree: false,
          doctoralDegreeDetails: []
        },
        sectorExperience: {
          experience: false,
          experienceDetails: []
        },
        naicsLevel1Options: {}
      },
      sgaWorkHistory: {
        userWorkHistory: []
      },
      sgaHiddenExtras: {
        workingPracticeActivities: []
      },
      sgaKnowledge: {
        knowledgeRegularlyUsed: []
      },
      sgaMindset: {
        mindsets: []
      },
      sgaSkills: {
        workingPracticeSkills: []
      },
      sgaTechnologies: {
        selectedTechnologies: [],
        customTechnologies: []
      },
      sgaHiddenTalents: {
        skillsKnowledgeOutsideWork: []
      },
      sgaCulture: {
        selectedCultureOptions: [],
        commuteDistance: "",
        transportation: []
      },
      sgaCertifications: {
        userCertifications: []
      },
      cvCollection: [],
      showProfile: true,
      base64Raw: null,
      locale: null,
      profile: {},
      profileSettings: [],
      activitiesError: null
    };
  },
  computed: {
    currentSga() {
      return this.$store.state.sga.current_sga;
    },
    currentUser() {
      return this.$store.state.account.current_user;
    },
    workActivities() {
      return this.$store.state.sga.workActivities;
    },
    knowledgeRegularlyUsed: {
      get() {
        // if (this.isLoading) return {};
        return Object.assign(
          {},
          ...Object.entries({
            ...this.workActivities.map(v => v.activity)
          }).map(an => {
            let oo = null;
            try {
              const fid = this.sgaHiddenExtras.workingPracticeActivities.find(
                wpa => wpa.selection === an[1]
              );
              if (fid) oo = fid;
            } catch (error) {}
            return {
              [an[1]]: {
                name: an[1],
                in: oo && oo.value.includes("IN"),
                out: oo && oo.value.includes("OUT")
              }
            };
          })
        );
      },
      set(v) {
        console.log(v);
      }
    },
    page1() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page1
        : {};
    },
    page2() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page2) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page2;
        } else {
          return {
            sgaYourJob: this.sgaYourJob,
            taskSearch: this.taskSearch,
            hiddenTasks: this.hiddenTasks
          };
        }
      } else {
        return {
          sgaYourJob: this.sgaYourJob,
          taskSearch: this.taskSearch,
          hiddenTasks: this.hiddenTasks
        };
      }
    },
    page3() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page3) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page3;
        } else {
          return { sgaEducation: this.sgaEducation };
        }
      } else {
        return { sgaEducation: this.sgaEducation };
      }
    },
    page4() {
      this.sgaWorkHistory.userWorkHistory.forEach(element => {
        if (element.workedFrom == "0001-01-01T00:00:00") {
          element.workedFrom = null;
        }
        if (element.workedTo == "0001-01-01T00:00:00") {
          element.workedTo = null;
        }
      });

      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page4) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page4;
        } else {
          return { sgaWorkHistory: this.sgaWorkHistory };
        }
      } else {
        return { sgaWorkHistory: this.sgaWorkHistory };
      }
    },
    page5() {
      this.sgaCertifications.userCertifications.forEach(element => {
        if (element.acquiredDt == "0001-01-01T00:00:00") {
          element.acquiredDt = null;
        }
        if (element.expirationDt == "0001-01-01T00:00:00") {
          element.expirationDt = null;
        }
        if (element.image == undefined) {
          element.image = null;
        }
      });

      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page5) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page5;
        } else {
          return {
            sgaCertifications: this.sgaCertifications,
            selectedCodeDetail: this.selectedCodeDetail
          };
        }
      } else {
        return {
          sgaCertifications: this.sgaCertifications,
          selectedCodeDetail: this.selectedCodeDetail
        };
      }
    },
    page6() {
      return {
        sgaHiddenExtras: this.sgaHiddenExtras
      };
    },
    page7() {
      return {
        sgaKnowledge: this.sgaKnowledge
      };
    },
    page8() {
      return {
        sgaTechnologies: this.sgaTechnologies,
      };
    },
    page9() {
      return {
        sgaMindset: this.sgaMindset,
      };
    },
    page10() {
      return {
        sgaSkills: this.sgaSkills,
      };
    },
    page11() {
      return {
        sgaHiddenTalents: this.sgaHiddenTalents,
      };
    },
    page12() {
      return {
        sgaCulture: this.sgaCulture,
      };
    }
  },
  methods: {
    closeResumeListModal() {
      this.showResumeListModal = false;
    },
    showResumeList() {
      this.$store
        .dispatch(
          "onlineprofile/getuserprofilepagesettings",
          this.currentUser.id
        )
        .then(res => {
          this.profileSettings = res.filter(d => d.isActive == true);
          this.loading = false;
          this.showResumeListModal = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    displayResume(setting) {
      var obj = {
        userid: this.currentUser.id,
        cvid: setting.id
      };
      this.$store
        .dispatch("account/getprofiledetails", obj)
        .then(res => {
          this.profile = res;
          this.showProfile = this.profile?.configuration?.profileConfiguration?.personalInformation?.profilePhoto;
          this.closeResumeListModal();

          this.$refs.cv.showCV(true);
          // this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            // action();
            window.print();
            x();
          }, 500);
        })
        .catch(res => {});
    },
    storeSection() {
      this.isLoading = true;
      if (this.sgaHiddenExtras.workingPracticeActivities.length == 0) {
        this.activitiesError = "Please select at least 1 activity.";
        this.isLoading = false;
        return false;
      }

      this.activitiesError = null;
      this.sgaHiddenExtras.workingPracticeActivities = this.getObjectForSubmission();
      this.currentSga.sgaHiddenExtras = this.sgaHiddenExtras;

      this.currentSga.sgaHiddenExtras.isComplete = true;
      if (this.currentSga.sgaHiddenExtras.id == null) {
        this.$store
          .dispatch("sga/postsga", this.currentSga)
          .then(() => {
            this.$router.app.$emit("navigateToNextStep");
          })
          .catch(res => {
            this.modelState = res.errors;
            this.isLoading = false;
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$store
          .dispatch("sga/putsga", this.currentSga)
          .then(() => {
            this.$router.app.$emit("navigateToNextStep");
          })
          .catch(res => {
            this.modelState = res.errors;
            this.isLoading = false;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }

      sessionStorage.setItem(
        "sgaDataForPrinting",
        JSON.stringify({
          page1: this.page1,
          page2: this.page2,
          page3: this.page3,
          page4: this.page4,
          page5: this.page5,
          page6: { sgaHiddenExtras: this.currentSga.sgaHiddenExtras }
        })
      );
    },
    handleKnowledgeChange(obj, val, a) {
      this.$nextTick(() => {
        let oo = null;

        try {
          const fid = this.sgaHiddenExtras.workingPracticeActivities.findIndex(
            wpa => wpa.selection === obj
          );
          if (fid !== -1) oo = fid;
        } catch (error) {}

        if (oo == null) {
          this.sgaHiddenExtras.workingPracticeActivities.push({
            selection: obj,
            value: `${val}`
          });
        } else {
          const v = this.sgaHiddenExtras.workingPracticeActivities[oo];
          //correct old data that saved INOUT (old implemenation where we saved INOUT)
          if (v.value == "INOUT") v.value = "OUT";

          if (v.value.includes(val)) {
            // remove val from string
            v.value = v.value.replace(val, "");
          } else {
            // add val to string
            v.value = `${v.value}${val}`;
          }
          if (v.value === "")
            delete this.sgaHiddenExtras.workingPracticeActivities[oo];
          this.sgaHiddenExtras.workingPracticeActivities = this.sgaHiddenExtras.workingPracticeActivities.filter(
            Boolean
          );
          // this.$set(this.SgaHiddenExtras.WorkingPracticeActivities[obj], [val.toLowerCase()], a);
        }
      });

      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    mapToCurrentActivities(v) {
      if (typeof v === "object") return;
      const nn = {};
      v.forEach(oc => {
        nn[oc.selection] = {
          in: oc.value.includes("IN"),
          out: oc.value.includes("OUT")
        };
      });

      this.$set(this.sgaHiddenExtras, "WorkingPracticeActivities", nn);
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    getObjectForSubmission() {
      return this.sgaHiddenExtras.workingPracticeActivities;
    },
    printPage(action) {
      this.loadPages(action);
    },
    loadPages(action) {
      this.$store.dispatch("sga/getsga").then(data => {
        this.sgaYourJob = data.sgaYourJob || this.sgaYourJob;
        this.sgaEducation = data.sgaEducation || this.sgaEducation;
        this.sgaWorkHistory = data.sgaWorkHistory || this.sgaWorkHistory;
        this.sgaCertifications =
          data.sgaCertifications || this.sgaCertifications;
        this.sgaHiddenExtras = data.sgaHiddenExtras || this.sgaHiddenExtras;
        this.sgaKnowledge = data.sgaKnowledge || this.sgaKnowledge;
        this.sgaMindset = data.sgaMindset || this.sgaMindset;
        this.sgaSkills = data.sgaSkills || this.sgaSkills;
        this.sgaHiddenTalents = data.sgaHiddenTalents || this.sgaHiddenTalents;
        this.sgaCulture = data.culture || this.sgaCulture;
        this.sgaTechnologies = data.sgaTechnologies || this.sgaTechnologies;

        this.$store
          .dispatch("sga/getSGAforPrint", this.sgaHiddenExtras)
          .then(() => {
            this.$refs.cv.hideCV();
            this.$refs.questionnaire.showQuestionnaire();
            action();
            this.$refs.questionnaire.hideQuestionnaire();
          });
      });
    },
    printPageAsCV(action) {
      this.cvCollection = [
        {
          userInfo: this.currentUser,
          image: this.base64Raw,
          survey: this.currentSga
        }
      ];
      this.$confirm(`Do you want to include profile picture?`, "Warning", {
        confirmButtonText: "Yes",
        dangerouslyUseHTMLString: true,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "No",
        center: true
      })
        .then(() => {
          this.$refs.cv.showCV(true);
          this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            action();
            x();
          }, 500);
          //this.$refs.cv.hideCV();
        })
        .catch(() => {
          this.$refs.cv.showCV(false);
          this.showProfile = false;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            action();
            x();
          }, 500);
        });
    },
    checkIfContainsOrganization(val) {
      var str = val;
      var isTrue = false;
      if (this.locale == "en-uk") {
        isTrue = str.includes("Organization");
        if (isTrue) {
          var str = str.replace("Organization", "Organisation");
          isTrue = false;
        }
        isTrue = str.includes("Organizational");
        if (isTrue) {
          var str = str.replace("Organizational", "Organisational");
          isTrue = false;
        }
        isTrue = str.includes("Organizing");
        if (isTrue) {
          var str = str.replace("Organizing", "Organising");
          isTrue = false;
        }
        return str;
      } else {
        return val;
      }
    }
  }
};
</script>
